import { FC } from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export const AffiliatePanel: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-4 p-4 bg-green-50 rounded-lg">
      <p className="text-green-700 mb-4">
        Ya eres parte de nuestro programa de socios. Accede a tu panel para ver tus estadísticas y comisiones.
      </p>
      <Button 
        onClick={() => navigate('/partners')}
        className="w-full sm:w-auto bg-primary hover:bg-primary-dark text-white"
      >
        Ir al Panel de Partners
      </Button>
    </div>
  );
};